import { array, boolean, number, object } from "yup";

import { Translate } from "@/redux/modules/value/translations/translations.provider";

import { string } from "./general.RHF";

export const text = string()
    .nullable()
    .min(50)
    .transform((value) => (value === "" ? null : value));

export const title = string()
    .nullable()
    .max(50)
    .transform((value) => (value === "" ? null : value));

export const nickname = string().nullable().min(2).required();

export const terms = boolean()
    .required()
    .oneOf([true], () => () => (t: Translate) => {
        return t("form.validation.input.termsAndConditions.required");
    });

export const rating = (min: number, max: number) =>
    number().nullable().min(min).max(max).required();

export const optionalRating = (min: number, max: number) =>
    number().nullable().min(min).max(max);

export const brandComment = string().nullable().max(5000);

export const brandScore = number().nullable().min(0).max(10);

export const photos = (amount: number) =>
    array()
        .ensure()
        .max(amount)
        .of(
            object({
                url: string().required(),
                caption: string().nullable().max(100)
            })
        );
